import React, {useContext, useEffect, useState} from 'react';
import Auxiliary from '../../../util/Auxiliary';
import Title from '../../../components/Title/Title';
import {Formik} from 'formik';
import RegisterForm from '../../Register/RegisterForm';
import {ParamsContext} from '../../Context/ParamsContext';
import axios from '../../../util/Api';
import {message} from 'antd';
import {useHistory} from 'react-router-dom';
import {updateSchema} from '../../Register/schema';

const Index = () => {
  const history = useHistory();
  const params = useContext(ParamsContext);
  const [loading, setLoading] = useState(true);
  const [passport, setPassport] = useState(null);

  useEffect(() => {
    setLoading(true);
    const url = `/passport/detail?id=${params.id}`;
    axios.get(url).then(resp => {
      setPassport(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data personel");
    });
  }, [params.id]);

  const getInitialValues = () => {
    return {
      id: passport.id,
      vendor: passport.vendor.name,
      name: passport.name,
      identity: {
        number: passport.identity.number,
        type: passport.identity.type.id, //1=ktp,2=kitas, 3=paspor
        file: "" 
      },
      nationality: passport.nationality, // wni/wna
      gender: passport.gender, //L/P
      blood_type: passport.blood_type,
      health: {
        status: passport.health.status.id, // 1=fit, 2=non fit, 3=fit with note
        notes: passport.health.notes, // jika status selain 3, kasih nilai null
        file: "" //tbd
      },
      department: passport.department.id, //1=Project Management, 2=Engineeering, 3=Procurement
      position: passport.position.id, //1=Manager, 2=Koordinator, 3=HSE, 99=Lainnya
      email: passport.email,
      phone: passport.phone,
      emergency_contact: passport.emergency_contact,
      education: passport.education.id, //1=SD, 2=SMP, 3=SMA/SMK, 4=D3, 5=S1/D4, 6=S2, 7=S3, 99=Lainnya
      // work_experience: passport.work_experience.since, //2012-04-23
      work_experience_pp: passport.work_experience_pp ? passport.work_experience_pp.since : "",
      work_experience_nonpp: passport.work_experience_nonpp ? passport.work_experience_nonpp.since : "",
      skills: passport.skills.reduce((arr, i) => {
        return [...arr, i.skills_id];
      },[]), //isinya bisa banyak je, disimpen di passport_skills
      skills_file: passport.skills_file ? passport.skills_file : [],
      sickness: passport.sickness ? passport.sickness.reduce((arr, i) => {
        return [...arr, i.sickness_id];
      },[]) : [], //isinya bisa banyak, disimpen di passport_sickness
      training_competency: passport.training_competencies ? passport.training_competencies.reduce((arr, i) => {
        return [...arr, i.training_competency_id];
      },[]) : [],
      job_specialization: passport.job_specializations && passport.job_specializations.length > 0 ? passport.job_specializations[0].job_specialization_id : undefined,
    };
  }

  return (
    <Auxiliary>
      <Title>Update Data Personel</Title>
      {loading ? "Sedang memuat..." : (
        <Formik
          initialValues={getInitialValues()}
          validationSchema={updateSchema}
          onSubmit={values => {
            const data = {
              before: {...getInitialValues()},
              after: {...values}
            };

            const url = `/passport/update?id=${values.id}`;
            axios.post(url, data).then(resp => {
              history.push(`/passport/detail?id=${values.id}`);
              message.success("Perubahan data personel telah berhasil disimpan");
            }).catch(err => {
              message.error("Gagal memperbarui data personel");
            });
          }}
        >
          <RegisterForm passport={passport} title="Form Update Data Personel" />
        </Formik>
      )}
    </Auxiliary>
  );
}

export default Index;